import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '@viso/core/data-access';
import { Environment, Response } from '@viso/core/models';
import { MasterListType } from '@viso/core/enums';

@Injectable({
  providedIn: 'root',
})
export class PendingLocationsServicesService {
  constructor(
    private http: HttpClient,
    @Inject(ENVIRONMENT) private environment: Environment
  ) {}

  getPendingForApprovalRequests() {
    return this.http
      .get<Response<any>>(
        `${this.environment.API_URL}/vendor/pending-services-locations`
      );
  }

  deletePendingApprovals(id: string, type: MasterListType) {
    return this.http.request<Response<any>>('DELETE', 
      `${this.environment.API_URL}/vendor/pending-services-locations/${id}`,
      { body: { type } }
    );
  }

}
